import { atom } from 'recoil';

export const ModeAtom = atom({
  key: 'mode',
  default: 'dark',
});
